function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import classNames from "classnames";
import { withNativeProps } from "../../utils/with-native-props";
import { useThrottleFn } from "ahooks";
import { mergeProps } from "../../utils/with-default-props";
import { Sidebar } from "./sidebar";
import { convertPx } from "../../utils/convert-px";
import { traverseReactNode } from "../../utils/traverse-react-node";
var classPrefix = "tc-index-bar";
var defaultProps = {
  sticky: true
};
export var IndexBar = /*#__PURE__*/forwardRef(function (p, ref) {
  var props = mergeProps(defaultProps, p);
  var titleHeight = convertPx(35);
  var bodyRef = useRef(null);
  var indexItems = [];
  var panels = [];
  traverseReactNode(props.children, function (child) {
    var _a;
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    indexItems.push({
      index: child.props.index,
      brief: (_a = child.props.brief) !== null && _a !== void 0 ? _a : child.props.index.charAt(0)
    });
    panels.push(withNativeProps(child.props, /*#__PURE__*/React.createElement("div", {
      key: child.props.index,
      "data-index": child.props.index,
      className: "".concat(classPrefix, "-anchor")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-anchor-title")
    }, child.props.title || child.props.index), child.props.children)));
  });
  var _useState = useState(function () {
      var firstItem = indexItems[0];
      return firstItem ? firstItem.index : null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  useImperativeHandle(ref, function () {
    return {
      scrollTo: scrollTo
    };
  });
  function scrollTo(index) {
    var _a;
    var body = bodyRef.current;
    if (!body) return;
    var children = body.children;
    for (var i = 0; i < children.length; i++) {
      var panel = children.item(i);
      if (!panel) continue;
      var panelIndex = panel.dataset.index;
      if (panelIndex === index) {
        body.scrollTop = panel.offsetTop;
        setActiveIndex(index);
        if (activeIndex !== index) {
          (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, index);
        }
        return;
      }
    }
  }
  var _useThrottleFn = useThrottleFn(function () {
      var _a;
      var body = bodyRef.current;
      if (!body) return;
      var scrollTop = body.scrollTop;
      var elements = body.getElementsByClassName("".concat(classPrefix, "-anchor"));
      for (var i = 0; i < elements.length; i++) {
        var panel = elements.item(i);
        if (!panel) continue;
        var panelIndex = panel.dataset.index;
        if (!panelIndex) continue;
        if (panel.offsetTop + panel.clientHeight - titleHeight > scrollTop) {
          setActiveIndex(panelIndex);
          if (activeIndex !== panelIndex) {
            (_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, panelIndex);
          }
          return;
        }
      }
    }, {
      wait: 50,
      trailing: true,
      leading: true
    }),
    checkActiveIndex = _useThrottleFn.run;
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(classPrefix), _defineProperty({}, "".concat(classPrefix, "-sticky"), props.sticky))
  }, /*#__PURE__*/React.createElement(Sidebar, {
    indexItems: indexItems,
    activeIndex: activeIndex,
    onActive: function onActive(index) {
      scrollTo(index);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-body"),
    ref: bodyRef,
    onScroll: checkActiveIndex
  }, panels)));
});